import { Nullable, WithErrors } from "../../types";
import {
    AdvancedMedicalInfo,
    AdvancedMedicalInfoFromAPI,
    BasicMedicalInfo,
    BasicMedicalInfoFromAPI,
} from "./types";

export const convertBasicMedicalInfoFromAPI = (
    dataFromAPI: Nullable<BasicMedicalInfoFromAPI>
): Nullable<WithErrors<BasicMedicalInfo>> => {
    return !dataFromAPI
        ? null
        : {
              antiarrhythmicDrugs: dataFromAPI.antiarrhythmic_drugs,
              currentIllness: dataFromAPI.current_illness,
              allCurrentIllness: dataFromAPI.all_current_illness,
          };
};

export const invertBasicMedicalInfoData = (
    data: BasicMedicalInfo
): Omit<BasicMedicalInfoFromAPI, "all_current_illness"> => {
    return {
        antiarrhythmic_drugs: data.antiarrhythmicDrugs,
        current_illness: data.currentIllness,
    };
};

export const convertAdvancedMedicalInfoFromAPI = (
    dataFromAPI: Nullable<AdvancedMedicalInfoFromAPI>
): Nullable<WithErrors<AdvancedMedicalInfo>> => {
    return !dataFromAPI
        ? null
        : {
              familyIllness: dataFromAPI.family_illness,
              allFamilyIllness: dataFromAPI.all_family_illness,
          };
};

export const invertAdvancedMedicalInfoData = (
    data: AdvancedMedicalInfo
): Omit<AdvancedMedicalInfoFromAPI, "all_family_illness"> => {
    return {
        family_illness: data.familyIllness,
    };
};
